import { render, staticRenderFns } from "./WhyVape.vue?vue&type=template&id=9e7c653c&"
import script from "./WhyVape.vue?vue&type=script&lang=js&"
export * from "./WhyVape.vue?vue&type=script&lang=js&"
import style0 from "./WhyVape.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports